import {
  ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_STARTED,
  ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_SUCCEEDED,
  ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_FAILED,
  ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_PAGE,
  ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ITEMS_PER_PAGE,
  ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER,
  ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER_BY,
  ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY,
  ADDRESS_BOOK_CONTACTS_PAGINATED_SET_FILTER,
  ADDRESS_BOOK_CONTACTS_PAGINATED_CLEAR
} from '#action/types';
import { requestStatuses as statuses } from '#helper';

const defaultState = {
  status: statuses.idle,
  addressbooks: null,
  contacts: [],
  error: null,
  page: 1,
  itemsPerPage: 5,
  order: 'asc',
  orderBy: 'addressbook',
  pages: 0,
  filter: null,
  filterBy: ['fullName', 'company', 'address', 'email']
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_STARTED:
      return { ...state, status: statuses.loading, error: null };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_SUCCEEDED:
      const updates = {
        ...state,
        status: statuses.succeeded,
        contacts: action.payload,
        pages: Math.ceil(action.totalCount / state.itemsPerPage)
      };
      if (Array.isArray(action.addressbooks)) {
        updates.addressbooks = action.addressbooks;
      }
      return updates;
    case ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_FAILED:
      return { ...state, status: statuses.failed, contacts: [], error: action.error };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_PAGE:
      return { ...state, page: action.payload };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ITEMS_PER_PAGE:
      return { ...state, itemsPerPage: action.payload };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER:
      return { ...state, order: action.payload };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER_BY:
      return { ...state, orderBy: action.payload };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY:
      return { ...state, order: action.payload.order, orderBy: action.payload.orderBy };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_SET_FILTER:
      return { ...state, filter: action.payload };
    case ADDRESS_BOOK_CONTACTS_PAGINATED_CLEAR:
      return defaultState;
    default:
      return state;
  }
};
